import { render } from "./Tab2.vue?vue&type=template&id=3975d470&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=ts"
export * from "./Tab2.vue?vue&type=script&lang=ts"

import "./Tab2.vue?vue&type=style&index=0&id=3975d470&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3975d470"

export default script